<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ct2-4 animate-target" v-animate-in>Internationally, ADA, ESC, and KDIGO all recommend regular UACR and eGFR testing to inform treatment decisions for people with CKD and T2D<sup>1,3,6,8-9</sup></div>
    <img class="ct2-4-img animate-target" v-animate-in src="../../assets/images/p2-4/4-2.png" />
    <div class="ct2-4-bd">
      <div class="ct24-1 animate-target" v-animate-in>
        <div>
          <p>“In people with established CKD, urinary albumin (eg, spot UACR) and eGFR should be monitored 1–4 times per year depending on the stage of the kidney disease.”<sup>1</sup></p>
          <p>2024 ADA Standards of Care</p>
        </div>
        <div>
          <p>“Assess albuminuria in adults, or albuminuria/proteinuria in children, and GFR at least annually in people with CKD...Assess albuminuria and GFR more often for individuals at higher risk of CKD progression when measurement will impact therapeutic decisions.”<sup>7</sup></p>
          <p>2024 KDIGO Guidelines</p>
        </div>
      </div>
      <div  class="ct24-1 animate-target" v-animate-in>
        <div>
          <p>“It is recommended that [people] with diabetes are routinely screened for kidney disease by assessing eGFR defined by CKD-EPI and UACR.”<sup>8</sup></p>
          <p>2023 ESC Guidelines</p>
        </div>
        <div>
          <p>“For most people, CKD is not identified as a result of symptoms; CKD is often diagnosed through routine screening. Both the ADA and KDIGO recommend annual screening of [people] with diabetes for CKD.”<sup>3</sup></p>
          <p>2022 ADA and KDIGO Consensus Report</p>
        </div>
      </div>
    </div>
    <GoNext class="animate-target" v-animate-in href="/section2/2-5">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
export default {
  name: "s2-4",
  components: {SectionTitle, GoNext, ContentNotice},
  data(){
    return {
      noticeTxt:"ADA, American Diabetes Association; CKD-EPI, Chronic Kidney Disease Epidemiology Collaboration; CVD, cardiovascular disease; DKD, diabetic kidney disease; DM, diabetes mellitus; (e)GFR, (estimated) glomerular filtration rate; ESC, European Society of Cardiology; GFR, glomerular filtration rate; KDIGO, Kidney Disease: Improving Global Outcomes; RACGP, Royal Australian College of General Practitioners; UACR, urine albumin-to-creatinine ratio.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. American Diabetes Association (Section 11: Chronic kidney disease and risk management: standards of care in diabetes). Diabetes Care. 2024;47(Suppl 1):S219 S230. doi:10.2337/dc24-S011.<br/>"
      +"2. 2McGill JB, <i>et al. BMJ Open Diabetes Res Care</i>. 2022;10(4):e002806. doi:10.1136/bmjdrc-2022 002806.<br/>"
      +"3. 3de Boer IH, <i>et al</i>. (Diabetes management in chronic kidney disease: a consensus report by the American Diabetes Association [ADA] and Kidney Disease: Improving Global Outcomes (KDIGO]). Diabetes Care. 2022:45(12):3075 3090. doi:10.2337/dci22 0027.<br/>"
      +"4. Kidney Disease: Improving Global Outcomes (KDIGO) CKD Work Group. Kidney Intl Suppl. 2013:3(1):1-150. do:10.1038/kisup.2012.73.<br/>"
      +"5. Rossing P. <i>et al. Am J Med</i>. 2022:135(5):576 580. doi:10.1016/.amimed.2021.11.019.<br/>"
      +"6. Blonde L, <i>et al</i>. American Association of Clinical Endocrinology Clinical Practice Guideline: developing a diabetes mellitus comprehensive care plan 2022 update. Endor Pract. 2022:(10):923-1049. do:10.4158/CS 2019 0472.<br/>"
      +"7. RACGP. Management of type 2 diabetes: A handbook for general practice. <a target='_blank' href='https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx' class='c-url'>https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx</a>.<br/>"
      +"8. Kidney Disease: Improving Global Outcomes (KDIGO) Diabetes Work Group. KDIGO 2024 clinical practice guideline for diabetes management in chronic kidney disease. Kidney It. 2024:102/5S):S1-S127. doi:10.1016/i.kint.2022.06.008.<br/>"
      +"9. Marx N. <i>et al</i>. ESC Guidelines for the management of cardiovascular disease in patients with diabetes. ur Heart J. 2023:44(39):4043 doi:10.1093/eurhearti/ehad192.<br/>",
      title:'Regular measurement of UACR and eGFR is necessary to manage T2D, with or without CKD<sup>1-7</sup>'
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section2/s2.css";
.ct2-4 {
  font-size: 20px;
  color: #000;
  font-weight:bold;
  margin-top: 20px;
}
.ct2-4-img {
  width: 100%;
}
.ct2-4-bd {
  display: flex;
  flex-direction: column;
}
.ct2-4-bd .ct24-1 {
  display:flex;
  gap: 20px;
  margin-top: 20px;
}
.ct2-4-bd .ct24-1 div {
  background-color:RGB(216 216 216 / 25%);
  flex: 1;
  width: calc(50% - 10px);
  padding: 20px;
}
.ct2-4-bd .ct24-1 div p {
  font-size: 20px;
}
.ct2-4-bd .ct24-1 div p:last-child {
  font-weight:bold;
  color: #10384F;
  font-size: 20px;
  margin-top: 20px;
}
</style>
